module.exports = __webpack_public_path__ + "static/hcgummybears-8f79b2c305c25c10aaf4dd28a1f6a813.jpg";